"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.auditLogFactory = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const lodash_1 = require("lodash");
const AuthoredEvidence = __importStar(require("../../composite/evidence/authored-evidence/authored-evidence"));
const evidence_1 = require("../../composite/evidence/evidence");
const empty_component_1 = require("../../utils/empty-component");
const alog_columns_1 = require("./alog-columns");
const alog_fields_1 = require("./alog-fields");
/**
 * todo: use domain evidence

 */
function auditLogFactory({ url, reportTag, }) {
    return function Auditlog() {
        const intl = (0, react_intl_1.useIntl)();
        const evidence = AuthoredEvidence.useAuthoredEvidence({
            version: 3,
            identifier: 'ALOG',
            apiProps: {
                url,
            },
            tableProps: {
                columns: (0, alog_columns_1.useColumns)(),
                tableName: intl.formatMessage({
                    id: 'EAS_ALOG_TABLE_TITLE',
                    defaultMessage: 'Auditní log',
                }),
                reportTag,
            },
            detailProps: {
                GeneralFieldsComponent: empty_component_1.EmptyComponent,
                FieldsComponent: alog_fields_1.AlogFields,
                toolbarProps: {
                    showBtn: lodash_1.stubFalse,
                    title: intl.formatMessage({
                        id: 'EAS_ALOG_DETAIL_TITLE',
                        defaultMessage: 'Auditní log',
                    }),
                },
            },
        });
        return react_1.default.createElement(evidence_1.Evidence, { ...evidence });
    };
}
exports.auditLogFactory = auditLogFactory;
auditLogFactory.useColumns = alog_columns_1.useColumns;
auditLogFactory.Fields = alog_fields_1.AlogFields;
//# sourceMappingURL=alog.js.map